export const TITLE = 'Our Team';

export const TEAM_INFO =
  'Founded in 2017 in the heart of Silicon Valley. Powered and inspired by the local entrepreneural spirit, we are ready to bring disruptive innovations to any kind of business.';
